import {Component, Prop} from "vue-property-decorator"
import {ModalBase} from "@/types/ModalBase";

@Component({
    components: {},
})
export default class Modal extends ModalBase {
    @Prop({required: true})
    title!: string
    @Prop({default: () => false})
    private completeDisabled!: boolean
    @Prop({default: () => false})
    private cancelDisabled!: boolean
    @Prop({default: () => false})
    private centered!: boolean
    @Prop()
    private width!: number;
}
